export default `
  mutation updateOrganisationAiSettings($id: String!, $allowedAiVersions: [Int], $defaultAiVersion: Int) {
    updateOrganisationAiSettings(id: $id, allowedAiVersions: $allowedAiVersions, defaultAiVersion: $defaultAiVersion) {
      id
      allowedAiVersions
      defaultAiVersion
      updatedAt
    }
  }
`
